export default __webpack_public_path__ + "static/media/pending.1a492b3d.png";